<template>
    <modal-base lead-state="answered">
        <template #subtitle>Calling your lawyer</template>
    </modal-base>
</template>

<script>
    export default {
        mounted() {
            // this.$store.commit('card', 'contact');
        }
    }
</script>
